
import type { TwitterBlockProps } from './types';
import { Button } from '@digdir/designsystemet-react';

export type { TwitterBlockProps };

export function TwitterBlock({ twitterUrl, twitterTitle }: TwitterBlockProps) {
  const handleTwitterClick = () => {
    window.open(twitterUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button 
      onClick={handleTwitterClick}
      variant="secondary"
      className="border my-4"
    >
      {twitterTitle}
    </Button>
  );
}